import { LOCATION_VARIATIONS_PATTERN } from '../constants';

/**
 * Cleans input value by removing location variations pattern
 */
export const cleanInputValue = (value: string): string =>
  value.replace(new RegExp(`\\s*\\((${LOCATION_VARIATIONS_PATTERN})\\)$`), '');
